import { render, staticRenderFns } from "./FacebookGroup.vue?vue&type=template&id=5285f986&scoped=true&"
import script from "./FacebookGroup.vue?vue&type=script&lang=js&"
export * from "./FacebookGroup.vue?vue&type=script&lang=js&"
import style0 from "./FacebookGroup.vue?vue&type=style&index=0&id=5285f986&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5285f986",
  null
  
)

export default component.exports